<template>
  <div class="ui inverted segment">
    <div class="ui header">
      <i class="envelope icon"/>
      {{ localization.consentPage.consentTitle }}
    </div>

    <div v-html="localization.consentPage.consentBody"/>

    <br>
    <div
      class="ui right floated tertiary circular button"
      @click="giveConsent"><i class="checkmark icon"/>{{ localization.consentPage.agree }}</div>
    <div
      @click="quitConsent"
      class="ui left floated tertiary circular button"><i class="close icon"/>{{ localization.consentPage.disagree }}</div>
    <br>
    <br>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: '',
  data () {
    return {
      hasError: false
    }
  },
  methods: {
    ...mapActions(['matchUser', 'updateBrazeConsent']),
    quitConsent () {
      this.$router.push({ name: 'Login' })
    },
    giveConsent () {
      this.matchUser().then(() => {
        this.updateBrazeConsent(true).then(() => {
        }).catch(error => {
          Rollbar.error('Error updating Braze consent for ' + this.userId, error)
        })
      }, (error) => {
        Rollbar.error(error)
        this.$router.push({name: 'ErrorMessage'})
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/study/ConsentRequest.vue